import Provider from './Provider';
import { loadScript } from 'Misc/loaders';

export default class MoatProvider extends Provider {
  constructor(container) {
    super(container);
    this.name = '_moatApi';
    this.eventQueue = [];
    this.partnerCode = 'acuityjsvideo587693816634';
  }

  update(state, prevState, changes) {
    if(!this.ready && state.configuration.Media.length) {
      this.ready      = true;
      this.api        = this.loadAPI(state.configuration.Ad_Context, state.media);
      this.eventQueue = state.host.sent.slice(0).map(this.eventFormat(state.media));
    }

    if(this.api && changes.host.sent) {
      const len       = state.host.sent.length - prevState.host.sent.length,
            newEvents = state.host.sent.slice(-len);

      newEvents.forEach( type => this.api.dispatchEvent({
          adVolume: state.media.volume < 0 ? 0 : state.media.volume,
          type,
      }) );
    }
  }

  loadAPI(adContext, media) {
    const api      = this.createAPI(adContext, media),
          globalID = this.exposeBridge(api),
          tag      = loadScript(this.getSource(this.partnerCode, globalID), true);

    this.container.insertBefore(tag, this.container.childNodes[0] || null);
    return api;
  }

  createAPI(adContext, media) {
    const provider = this;

    return {
      adData: {
        ids      : provider.getConfig(adContext),
        duration : media.duration,
        url      : media.src
      },
      dispatchEvent(evt) {
        if(this.sendEvent) {
          provider.eventQueue.push(evt);
          this.sendEvent(provider.eventQueue.splice(0));
        } else {
          provider.eventQueue.push(evt);
        }
      }
    }
  }

  getConfig(adContext) {
    return {
      level1                 : adContext.IO,
      level2                 : adContext.Campaign,
      level3                 : adContext.Tactic,
      level4                 : adContext.Creative,
      slicer1                : adContext.Exchange,
      zMoatExchPub           : adContext.ExchangePub,
      viewMode               : 'na',
      zMoatRequestDomain     : adContext.Domain,
      zMoatSite              : adContext.SiteID,
      partnerCode            : this.partnerCode
    }
  }

  getSource(partnerCode, api) {
    return `https://z.moatads.com/${partnerCode}/moatvideo.js#${api}`;
  }

  eventFormat(media) {
    return type => ({
        adVolume: media.volume < 0 ? 0 : media.volume,
        type,
    });
  }
}



// WEBPACK FOOTER //
// ./src/Services/Measurement/ExternalProviders/MoatProvider.js